module.exports = __webpack_public_path__ + "static/media/upgrade-to-antv2.5d471c02.svg";